import React, { createContext, useContext, useState } from 'react';
//interfaces
import { ExceptionPriceBelowMinStateProps, ExceptionPriceBelowMinContextType, ExceptionPriceBelowMinContextProviderProps } from './interface';

export const ExceptionPriceBelowMinContext = createContext({} as ExceptionPriceBelowMinContextType);

export function ExceptionPriceBelowMinContextProvider(props: ExceptionPriceBelowMinContextProviderProps) {
  const { children } = props;

  const [exceptionPriceBelowMin, setExceptionPriceBelowMin] = useState<ExceptionPriceBelowMinStateProps>({isException: false});

  const updateExceptionPriceBelowMinState = (condition: boolean, reason?: string) => {
    const data: ExceptionPriceBelowMinStateProps = { isException: condition, reason: reason}
    setExceptionPriceBelowMin(data);
  };

  return (
    <ExceptionPriceBelowMinContext.Provider value={{
      exceptionPriceBelowMin,
      updateExceptionPriceBelowMinState
    }}>
      {children}
    </ExceptionPriceBelowMinContext.Provider>
  );
}

export const useExceptionPriceBelowMinContext = () => {
  return useContext(ExceptionPriceBelowMinContext);
};